import React from "react";
import "./styles.css";
import Text from "../typography/text";

const INSURANCE_STATUS_CONFIG = {
  pending: {
    backgroundColor: "var(--greyBackground)",
    color: "darkText",
  },
  submitted: {
    backgroundColor: "var(--blueBackground)",
    color: "darkText",
  },
  covered: {
    backgroundColor: "var(--successColorLight)",
    color: "successColorDark",
  },
  notCovered: {
    backgroundColor: "var(--failureColorLight)",
    color: "failureColorDark",
  },
  infoRequired: {
    backgroundColor: "var(--warningColorLight)",
    color: "failureColorDark",
  },
};

const InsuranceStatusPanel = ({
  variant = "default",
  insuranceStatus,
  insuranceStatusText,
  rightHeadingText,
  rightHeadingIcon,
  rightHeadingValue,
  leftHeadingIcon,
  buttonComponent,
  modalVariantComponent,
}) => {
  const defaultVariant = variant === "default";
  const modalVariant = variant === "modal";
  const hasRightHeading =
    !!rightHeadingText || !!rightHeadingValue || !!rightHeadingIcon;
  const rightHeadingContent = hasRightHeading ? (
    <div className="insurance-status-panel-right-container">
      <div
        className="insurance-status-panel-right-heading"
        style={{ gap: "8px" }}
      >
        {rightHeadingIcon}
        <Text variant="tinyText" color="lightText">
          {rightHeadingText}
        </Text>
      </div>
      <Text variant="bodyText">{rightHeadingValue}</Text>
    </div>
  ) : null;
  return (
    <div
      className="insurance-status-panel-parent-container"
      style={INSURANCE_STATUS_CONFIG[insuranceStatus]}
    >
      <div className="insurance-status-panel-left-container">
        <Text variant="bodyText">Insurance Status</Text>
        <div
          className="insurance-status-panel-right-heading"
          style={!!leftHeadingIcon ? { gap: "8px" } : null}
        >
          {!!leftHeadingIcon && leftHeadingIcon}
          <Text
            variant="h1"
            color={INSURANCE_STATUS_CONFIG[insuranceStatus]?.color}
          >
            {insuranceStatusText}
          </Text>
        </div>
      </div>
      {defaultVariant ? (
        <div className="insurance-status-panel-right-stack">
          {rightHeadingContent}
          {buttonComponent && (
            <div className="insurance-status-panel-button-container">
              {buttonComponent}
            </div>
          )}
        </div>
      ) : (
        rightHeadingContent
      )}
      {modalVariant && modalVariantComponent}
    </div>
  );
};

export default InsuranceStatusPanel;
